import { render, staticRenderFns } from "./PensionUnitSelectionList.vue?vue&type=template&id=7dfe20c2&scoped=true&"
import script from "./PensionUnitSelectionList.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionList.vue?vue&type=script&lang=ts&"
import style0 from "./PensionUnitSelectionList.vue?vue&type=style&index=0&id=7dfe20c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfe20c2",
  null
  
)

export default component.exports